// Add your custom JS here.
jQuery(document).ready(function($) {

	$('.slider-posts-area').each(function (index, sliderWrap) {
		var $slider = $(sliderWrap).find('.multiple-items');
		var $next = $(sliderWrap).find('.next');
		var $prev = $(sliderWrap).find('.prev');
		var $status = $('.pagingInfo');
		var $slickElement = $('.multiple-items');
		
		$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
		  //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
		  if(!slick.$dots){
			  return;
		  }
		  
		  var i = (currentSlide ? currentSlide : 0) + 1;
		  $status.text(i + '/' + (slick.$dots[0].children.length));
		});
		
		$slider.slick({
			dots: true,
			adaptiveHeight: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			nextArrow: $next,
			prevArrow: $prev,
			asNavFor: '.slider-for',
			
		});
	});
});

jQuery(document).ready(function($) {
	$('.slider-for').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  arrows: false,
	  fade: true,
	  asNavFor: '.multiple-items',
	});
});



jQuery(document).ready(function($) {

	$('.location-slider-area').each(function (index, sliderWrap) {
		var $slider = $(sliderWrap).find('.multiple-items');
		var $next = $(sliderWrap).find('.next');
		var $prev = $(sliderWrap).find('.prev');
		var $status = $('.pagingInfo');
		var $slickElement = $('.multiple-items');
		
		$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
		  //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
		  if(!slick.$dots){
			  return;
		  }
		  
		  var i = (currentSlide ? currentSlide : 0) + 1;
		  $status.text(i + '/' + (slick.$dots[0].children.length));
		});
		
		$slider.slick({
			dots: true,
			adaptiveHeight: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			nextArrow: $next,
			prevArrow: $prev,
			
		});
		
		// Check if there is only one slide
		var totalSlides = $('.slick-slider .slick-slide').length;
		if (totalSlides === 1) {
		  $('.slider-navigation-box').addClass('only-slide');
		}
	});
});



document.querySelectorAll('button[data-bs-toggle="tab"]').forEach((t,i)=>{
	t.addEventListener('show.bs.tab', function (e) {
		let targetClass = t.dataset.bsTarget
		var pane = document.querySelector('#nav-tabContentB '+targetClass)
		var sibling = document.querySelector('#nav-tabContentB .tab-pane.active')
		// hide 2nd pane sibling
		sibling.classList.remove('show')
		sibling.classList.remove('active')
		// show 2nd pane
		pane.classList.add('show')
		pane.classList.add('active')
	})  
})



(function(){
	var burger = document.querySelector('.mobile-btn-box'),
		header = document.querySelector('.sample-mobile'),
		body = document.querySelector('.page');
	
	burger.onclick = function() {
		header.classList.toggle('menu-opened'),
		body.classList.toggle('no-scroll');
	}
}());